/**
 * The platform-owned screens of the new-experiment flow, by connector type
 * (`docs/agent-access-redesign.html` §04, §07 "Code layout"). Each platform
 * exports a TargetPicker (step 2) and a RunSettingsForm (step 4); the shell
 * looks them up here. A type with no entry falls back on what it can do: one
 * that can `discover` gets the Orchestrator-style picker, anything else the
 * generic HTTP form (a path plus declared inputs).
 */

import type { Connector } from "./types";
import { httpScreens } from "./http";
import { orchestratorScreens } from "./orchestrator";
import type { PlatformScreens } from "./screens";

const BY_TYPE: Record<string, PlatformScreens> = {
  orchestrator: orchestratorScreens,
  http: httpScreens,
};

export function screensFor(connector: Connector): PlatformScreens {
  return (
    BY_TYPE[connector.type] ??
    (connector.capabilities.includes("discover") ? orchestratorScreens : httpScreens)
  );
}
